import { getApiFactory } from '../api/api-injector';
import { RequestOnBoardTenant } from '../api/supplier-api-interface-franchiseenetwork';
import { userDataStore } from '../supplier/common/current-user-data-store';
import { emptyGuid } from '../../webmodule-common/other/api/guid';

export class OnboardFranchisee {
  initialUserName: string | null = '';
  companyName: string | null = '';
  reference: string | null = '';
  initialName: string | null = '';
  initialPhone: string | null = '';
  initialEmail: string | null = '';
  initialJobTitle: string | null = '';
  licenseAllocation = 0;
  fabricatorModeEnabled = false;
}

export interface createFranchiseeOptions {
  franchisee: OnboardFranchisee;
  deploymentId: number;
  licensePoolId: number;
}

export async function onboardFranchisee(options: createFranchiseeOptions): Promise<boolean> {
  // This is a test
  const franchisee = options.franchisee;
  const onboardRequest: RequestOnBoardTenant = {
    companyName: franchisee.companyName,
    deploymentId: options.deploymentId,
    businessPhone: franchisee.initialPhone,
    initialName: franchisee.initialName,
    initialPhone: franchisee.initialPhone,
    initialUserEmail: franchisee.initialEmail,
    initialUserName: franchisee.initialUserName,
    licenseAllocation: franchisee.licenseAllocation,
    licensePoolId: options.licensePoolId,
    reference: franchisee.reference,
    initialJobTitle: franchisee.initialJobTitle,
    // Ignored on the wire: TaskCreateFranchisee overwrites it from InputCreateFranchisee's own
    // FabricatorModeEnabled, which is the `fabricatorModeEnabled` passed to createFranchisee below.
    // Set from that same source anyway, so the two can never disagree and nobody reads this one as
    // the value that counts. Required by RequestOnBoardTenant since the client was regenerated.
    fabricatorModeEnabled: franchisee.fabricatorModeEnabled
  };
  const api = getApiFactory().franchisee();
  const result = await api.createFranchisee({
    requestOnBoardTenant: onboardRequest,
    defaultPricingRuleId: emptyGuid,
    fabricatorModeEnabled: franchisee.fabricatorModeEnabled
  });
  if (result) {
    await userDataStore.reloadFranchiseeDetails();
    return true;
  }
  return false;
}
